import React from 'react';
import CampaignList from '../components/CampaignList';

const CampaignsPage = () => {
  return (
        <CampaignList />
  );
};

export default CampaignsPage; 